<template>
  <div
    :class="[
      'banner-container',
      ad.length > 0 ? 'half' : 'full',
      hasCouponPack ? '' : 'no-pack'
    ]"
  >
    <div class="banner-scroll">
      <div class="recharge-card" @click="goRechargeCard">
        <div class="detail">
          <div class="title">{{ APP_CONFIG.app_short_name }}充值卡</div>
          <span class="desc">{{ chargeDetail.desc }}</span>
        </div>
        <img class="image" src="@/images/coupon_center/recharge_img.png" />
      </div>

      <template v-if="ad.length > 0">
        <img
          v-for="(item, index) in ad"
          :key="index"
          v-expose-track="{
            coupon_center: {
              mapId: 'rechardAd',
              data: {
                spm: item.tickerInfo.click.spm,
                ...item.tickerInfo.data
              }
            }
          }"
          :src="item.imgUrl"
          class="ad-item"
          @click="goAd(item)"
        />
      </template>
    </div>
  </div>
</template>
<script>
import { cmsRedirect } from '@/common/cms/cms_redirect'
import { APP_CONFIG } from '@/defines/environment/config'
export default {
  name: 'RechargeBanner',
  props: {
    chargeAd: {
      type: Object,
      default: () => ({})
    },
    urlId: {
      type: String,
      default: ''
    },
    activityId: {
      type: String,
      default: ''
    },
    hasCouponPack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      APP_CONFIG
    }
  },
  computed: {
    chargeDetail() {
      return this.chargeAd?.chargeDetail
    },
    ad() {
      return this.chargeAd?.ad
    }
  },
  methods: {
    goRechargeCard() {
      this.$track(this.$trackMap.couponCenter.goRechard, {
        activity_id: String(this.activityId) || ''
      })
      if (!this.chargeDetail.url) return
      this.$autoRedirect(this.chargeDetail.url)
    },
    goAd(item) {
      const { tickerInfo } = item
      this.$track(
        tickerInfo.click.spm,
        Object.assign({}, tickerInfo.data, {
          activity_id: String(this.activityId) || '',
          cms_id: Number(this.urlId) || 0
        })
      )
      cmsRedirect(item?.action)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  width: 7.1rem;
  height: 1.54rem;
  margin: 0 auto;
  margin-top: 0.24rem;
  &.no-pack {
    margin-top: 0;
  }
  .banner-scroll {
    white-space: nowrap;

    overflow-x: auto;
    @include flex(row, flex-start, flex-start, nowrap);
  }
  .recharge-card {
    position: relative;

    height: 1.54rem;

    background: linear-gradient(to bottom, #fff1e7 0%, #fff 100%);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    border-radius: 0.16rem;

    @include flex(row, normal, center);
    .detail {
      @include flex-column;
      .title {
        font-size: 0.28rem;
        line-height: 0.32rem;
        font-weight: bold;
        color: #262626;
      }
      .desc {
        margin-top: 0.1rem;

        font-size: 0.24rem;
        line-height: 0.34rem;
        white-space: pre-wrap;
        color: #ff7d49;
      }
    }
    .image {
      position: absolute;

      width: 1.2rem;
      height: 1.2rem;
      margin-left: 0.32rem;
    }
  }
  .ad-item {
    min-width: 3.2rem;
    height: 1.54rem;
    margin-left: 0.2rem;

    border-radius: 0.16rem;
    &:nth-last-child(1) {
      margin-right: 0.2rem;
    }
  }
  &.half {
    .recharge-card {
      min-width: 3.2rem;
      padding-left: 0.2rem;
      .detail {
        width: 1.16rem;
      }
    }
    .image {
      top: 0.26rem;
      right: 0.08rem;
    }
  }
  &.full {
    .recharge-card {
      width: 100%;
      padding-left: 0.36rem;
    }
    .image {
      top: 0.16rem;
      right: 0.68rem;
    }
  }
}
</style>
